const hasIntersectionObserver =
  typeof window !== 'undefined' ? Boolean(window.IntersectionObserver) : false;

if (!hasIntersectionObserver) {
  import('intersection-observer')
    .then(() => {
      // eslint-disable-next-line no-console
      console.info('intersection-observer polyfill loaded.');
    })
    .catch(() => {});
}
